export const modalConstants = {
  DEFAULT: "DEFAULT",
  NUMBER_INPUT_FIELD: "NUMBER_INPUT_FIELD",
  TEXT_AREA_INPUT_FIELD: "TEXT_AREA_INPUT_FIELD",
};
